import React from 'react'
import { PDFViewer } from '@react-pdf/renderer'

// Create Document Component
const Pdf: React.FC<any> = (props) => (
  <PDFViewer style={{ width: '100%', height: 'calc(100vh - 4px)' }}>{props.children}</PDFViewer>
)

export default Pdf
